export default __webpack_public_path__ + "static/media/account-circle.762edc93.svg";